/**
 * 本地工具函数 - 替代 @wogoo/utils
 */

/**
 * 深拷贝对象
 * @param {*} obj - 要拷贝的对象
 * @returns {*} 拷贝后的对象
 */
export function deepClone(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  
  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }
  
  if (obj instanceof Array) {
    return obj.map(item => deepClone(item));
  }
  
  if (obj instanceof Object) {
    const clonedObj = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = deepClone(obj[key]);
      }
    }
    return clonedObj;
  }
  
  return obj;
}

/**
 * 生成唯一ID (GUID/UUID)
 * @returns {string} 唯一ID字符串
 */
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 获取设备号
 * 优先从 localStorage 获取,如果没有则生成一个新的
 * @returns {string} 设备号
 */
export function getDeviceNo() {
  const STORAGE_KEY = 'device_no';
  
  try {
    // 尝试从 localStorage 获取
    let deviceNo = localStorage.getItem(STORAGE_KEY);
    
    if (!deviceNo) {
      // 生成新的设备号
      deviceNo = guid();
      localStorage.setItem(STORAGE_KEY, deviceNo);
    }
    
    return deviceNo;
  } catch (error) {
    // 如果 localStorage 不可用,直接生成
    console.warn('localStorage not available, generating temporary device no');
    return guid();
  }
}
